import {Card} from "react-bootstrap";
import Carousel from "react-multi-carousel";
import * as React from "react";
import {ReactNode} from "react";
import {crossSellResponsive} from "../utils/helpers";
import {CrossSellCarouselModel} from "../models/view/crossSellCarouselModel";

interface IProps {
    model: CrossSellCarouselModel;
    children: ReactNode;
}

export const CrossSellCarousel = ({model: {carouselTitle}, children}: IProps) => {
    return (
        <>
            <Card body className="my-3 py-3 bg-light">
                {carouselTitle}
                <Carousel
                    swipeable={true}
                    itemAriaLabel={`${carouselTitle} product suggestion`}
                    draggable={false}
                    minimumTouchDrag={80}
                    showDots={false}
                    responsive={crossSellResponsive}
                    ssr={false}
                    infinite={true}
                    partialVisible={true}
                    keyBoardControl={true}
                    transitionDuration={500}
                    containerClass="container-with-dots"
                    dotListClass="custom-dot-list-style"
                    itemClass="border border-light"
                >
                    {children}
                </Carousel>
            </Card>
        </>
    )
}

